import {
  ActionType,
  IAction,
  IAppState,
  initialState
} from "../../../context/ServiceUsersContext";

const ServiceUsersReducer = (
  state: IAppState,
  action: IAction
): typeof initialState => {
  switch (action.type) {
    case ActionType.GET_PAST_SERVICES: {
      return {
        ...state,
        pastServices: action.pastServices
      };
    }
    case ActionType.GET_UPCOMING_SERVICES: {
      return {
        ...state,
        upComingServices: action.upComingServices
      };
    }
    case ActionType.GET_NON_FILTERED_SERVICES: {
      return {
        ...state,
        nonFilteredServices: action.nonFilteredServices
      };
    }
    default:
      throw new Error();
  }
};

export default ServiceUsersReducer;
